import { writable } from "svelte/store";
import { service } from "./services";
import type { ApiResultOfListOfGameServerDTO, GameServerDTO } from "./walletapi";

export const servers = writable<GameServerDTO[]>([]);

export async function RefreshServers() {
    try {
        let response: ApiResultOfListOfGameServerDTO = await service.walletapi.gameServerList({
            Token: sessionStorage.token,
        });

        if (response.Success && response.Data) {
            servers.set(response.Data);
        } else {
            console.error('Error getting server list:', response.ErrorMessage);
        }
    } catch (error) {
        console.error('API call error:', error);
    }
}

export function ServerChanged(server: GameServerDTO) {
    servers.update(servers => {
        const index = servers.findIndex(a => a.Id === server.Id);
        if (index >= 0) {
            servers[index] = server;
        }
        return servers;
    });
}

export function ServerAdded(server: GameServerDTO) {
    servers.update(servers => {
        servers = [...servers, server];
        return servers;
    });
}
